import ListViewActionsController from './list-view-actions.controller';
import { ListViewActionsProps } from './list-view-actions.model';

const ListViewActions = (props: ListViewActionsProps) => {
  return <ListViewActionsController {...props} />;
};

export default ListViewActions;
